import type { GetCompanySearchResponse } from '@iwoca/lapi-client/edge_de';

import { DE_COMPANY_TYPE } from '../../../CompanyDetails/CompanyDetailsDE/CompanyInputDE/CompanyInputManualDE/companyLegalForms';

// A single company from the register search. Legal form is NOT returned here —
// it comes from a separate fetchGetLegalForm(crefo_id) call after selection.
export type TCompanyMatch = NonNullable<
  GetCompanySearchResponse['data']
>[number];

// Reuse the desktop DE legal-form list (value + label) rather than duplicating it.
export { DE_COMPANY_TYPE };

// Maps a legal-form value (from fetchGetLegalForm) to its display label.
export const legalFormLabel = (value?: string): string =>
  DE_COMPANY_TYPE.find((type) => type.value === value)?.label ?? '';
